import { forwardRef } from 'react';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.css';

type Variant = 'primary' | 'quiet' | 'subtle' | 'icon';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: Variant | undefined;
  /** Bumps the primary variant to hero proportions. */
  readonly size?: 'default' | 'large' | undefined;
  readonly children?: ReactNode | undefined;
}

const VARIANT_CLASS: Record<Variant, string | undefined> = {
  primary: styles.primary,
  quiet: styles.quiet,
  subtle: styles.subtle,
  icon: styles.icon,
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = 'default', type = 'button', className, children, ...rest },
  ref,
) {
  const classes = [
    styles.base,
    VARIANT_CLASS[variant],
    variant === 'primary' && size === 'large' ? styles.primaryLarge : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    // eslint-disable-next-line react/button-has-type -- `type` is a typed prop with a safe default
    <button ref={ref} type={type} className={classes} {...rest}>
      {children}
    </button>
  );
});
